var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import cx from 'classnames';
import ActionLoader from 'common/ActionLoader/v2';
import SuccessIcon from 'common/SuccessIcon';
import styles from './Snackbar.css';
import Button from 'fk-cp-common-components/webComponents/V4/common/Button';
import closeIcon from 'fk-cp-common-components/images/cross_grey.svg';
import getImageUrl from '@utils/getImageUrl';
var initialState = {
    showSnackbar: false,
    infoText: null,
    subInfoText: null,
    icon: null,
    textStyle: null,
    iconStyle: null,
    showLoaderIcon: false,
    showSuccessIcon: false,
    showCloseBtn: false,
    actionButton: null,
    timer: null
};
var Snackbar = /** @class */ (function (_super) {
    __extends(Snackbar, _super);
    function Snackbar(props) {
        var _this = _super.call(this, props) || this;
        _this.startTimer = function (timer) {
            _this.timer = window.setTimeout(function () {
                _this.hideSnackbar();
            }, _this.state.timer || timer || 5000);
        };
        _this.showSnackbar = function (props) {
            if (!props.infoText) {
                return;
            }
            if (_this.timer) {
                window.clearTimeout(_this.timer);
                _this.setState(__assign({}, initialState));
            }
            _this.setState(__assign({ showSnackbar: true, open: true }, props), function () {
                _this.startTimer(props.timer);
            });
        };
        _this.hideSnackbar = function () {
            _this.setState({
                open: false
            }, function () {
                var closeAnimation = document.getElementsByClassName(styles.overlayClose)[0];
                closeAnimation &&
                    closeAnimation.addEventListener('animationend', function () {
                        _this.setState(__assign({}, initialState));
                    });
            });
        };
        _this.state = initialState;
        return _this;
    }
    Snackbar.prototype.onButtonClick = function () {
        this.hideSnackbar();
        this.state.onClick();
    };
    Snackbar.prototype.render = function () {
        var _a;
        var _this = this;
        var _b;
        var _c = this.state, infoText = _c.infoText, subInfoText = _c.subInfoText, icon = _c.icon, textStyle = _c.textStyle, iconStyle = _c.iconStyle, showLoaderIcon = _c.showLoaderIcon, showSuccessIcon = _c.showSuccessIcon, actionButton = _c.actionButton, showCloseBtn = _c.showCloseBtn, overlayStyles = _c.overlayStyles, buttonClass = _c.buttonClass;
        return this.state.showSnackbar ? (<div className={cx([styles.overlay], [overlayStyles], (_a = {}, _a[styles.overlayClose] = !this.state.open, _a))}>
				<div className={styles.infoWrapper}>
					{icon && (<div className={cx(styles.imgWrapper)}>
							<img src={getImageUrl(icon, 45, 45, 100, false)} className={styles[iconStyle]}/>
						</div>)}
					{showLoaderIcon && (<div className={styles.initLoader}>
							<ActionLoader />
						</div>)}
					{showSuccessIcon && <SuccessIcon />}
					<div className={cx(styles.textWrapper, styles[textStyle])}>
						<p>{infoText}</p>
						{subInfoText && <p className={styles.subHeaderText}> {subInfoText} </p>}
					</div>
					{showCloseBtn && (<div className={styles.closeIconWrapper}>
							<img src={closeIcon} className={styles.closeIcon} onClick={this.hideSnackbar}/>
						</div>)}
				</div>
				{((_b = actionButton) === null || _b === void 0 ? void 0 : _b.name) && (<Button onClick={function () { return _this.onButtonClick(); }} className={buttonClass} isDark={true}>
						{actionButton.name}
					</Button>)}
			</div>) : null;
    };
    return Snackbar;
}(Component));
export default Snackbar;
